import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60285e6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  class: "fill-current",
  preserveAspectRatio: "xMidYMid",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "fill-current",
  points: "1,0 20,10 1,20"
}
const _hoisted_4 = {
  key: 1,
  class: "fill-current",
  width: "6",
  height: "20",
  x: "0",
  y: "0"
}
const _hoisted_5 = {
  key: 2,
  class: "fill-current",
  width: "6",
  height: "20",
  x: "12",
  y: "0"
}
const _hoisted_6 = { class: "progress-bar" }
const _hoisted_7 = ["aria-valuemax", "aria-valuenow", "aria-valuetext"]
const _hoisted_8 = { class: "bg-white w-4 p-2 relative" }
const _hoisted_9 = {
  "aria-hidden": "true",
  class: "overflow-hidden absolute inset-0"
}
const _hoisted_10 = ["title", "aria-label"]
const _hoisted_11 = ["title", "aria-label"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-fullscreen" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["poster", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative overflow-hidden",
    onMouseover: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.fadeInTools && _ctx.fadeInTools(...args))),
    onMouseout: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.fadeOutTools && _ctx.fadeOutTools(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["tools-container", {'fade-out-tools': !_ctx.showTools && !_ctx.paused, 'fade-in-tools': _ctx.showTools}])
    }, [
      _createElementVNode("button", {
        type: "button",
        class: "btn-play p-5 flex justify-center items-center text-white mr-10",
        title: _ctx.playButtonLabel,
        "aria-label": _ctx.playButtonLabel,
        onKeydown: [
          _cache[0] || (_cache[0] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.lowerVolume && _ctx.lowerVolume(...args)), ["prevent"]), ["down"])),
          _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.boostVolume && _ctx.boostVolume(...args)), ["prevent"]), ["up"])),
          _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.rewindFiveSeconds && _ctx.rewindFiveSeconds(...args)), ["left"])),
          _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.skipFiveSeconds && _ctx.skipFiveSeconds(...args)), ["right"]))
        ],
        onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fadeInTools && _ctx.fadeInTools(...args))),
        onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fadeOutTools && _ctx.fadeOutTools(...args))),
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.togglePlaying && _ctx.togglePlaying(...args)))
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          (_ctx.paused)
            ? (_openBlock(), _createElementBlock("polygon", _hoisted_3))
            : _createCommentVNode("", true),
          (!_ctx.paused)
            ? (_openBlock(), _createElementBlock("rect", _hoisted_4))
            : _createCommentVNode("", true),
          (!_ctx.paused)
            ? (_openBlock(), _createElementBlock("rect", _hoisted_5))
            : _createCommentVNode("", true)
        ]))
      ], 40, _hoisted_1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          ref: "progressBarRef",
          class: "progress",
          tabindex: "0",
          role: "progressbar",
          "aria-valuemin": "0",
          "aria-valuemax": _ctx.durationRaw,
          "aria-valuenow": _ctx.currentTimeRaw,
          "aria-valuetext": _ctx.percentPlayed,
          onKeydown: [
            _cache[7] || (_cache[7] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.lowerVolume && _ctx.lowerVolume(...args)), ["prevent"]), ["down"])),
            _cache[8] || (_cache[8] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.boostVolume && _ctx.boostVolume(...args)), ["prevent"]), ["up"])),
            _cache[9] || (_cache[9] = _withKeys(
//@ts-ignore
(...args) => (_ctx.rewindFiveSeconds && _ctx.rewindFiveSeconds(...args)), ["left"])),
            _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.skipFiveSeconds && _ctx.skipFiveSeconds(...args)), ["right"])),
            _cache[11] || (_cache[11] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePlaying && _ctx.togglePlaying(...args)), ["prevent"]), ["space"]))
          ],
          onFocus: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.fadeInTools && _ctx.fadeInTools(...args))),
          onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.fadeOutTools && _ctx.fadeOutTools(...args))),
          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.skipToClickedTime && _ctx.skipToClickedTime(...args)))
        }, [
          _createElementVNode("div", {
            "aria-hidden": "true",
            class: "current-time-label pointer-events-none absolute",
            style: _normalizeStyle(_ctx.progressLabelStyling)
          }, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.currentTime), 1)
          ], 4),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", {
              class: _normalizeClass(["time-bar pointer-events-none", {'invisible': _ctx.currentTimeRaw === 0}]),
              style: _normalizeStyle(_ctx.progressBarStyling)
            }, null, 6)
          ])
        ], 40, _hoisted_7)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "flex items-center justify-center btn-sound",
        title: _ctx.soundButtonLabel,
        "aria-label": _ctx.soundButtonLabel,
        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.toggleSound && _ctx.toggleSound(...args))),
        onFocus: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.fadeInTools && _ctx.fadeInTools(...args))),
        onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.fadeOutTools && _ctx.fadeOutTools(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["icon-sound", {'muted': _ctx.muted}])
        }, null, 2)
      ], 40, _hoisted_10),
      _createElementVNode("button", {
        type: "button",
        class: "flex items-center justify-center btn-fullscreen",
        title: _ctx.fullscreenButtonLabel,
        "aria-label": _ctx.fullscreenButtonLabel,
        onFocus: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.fadeInTools && _ctx.fadeInTools(...args))),
        onBlur: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.fadeOutTools && _ctx.fadeOutTools(...args))),
        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.enterFullScreen && _ctx.enterFullScreen(...args)))
      }, _hoisted_13, 40, _hoisted_11)
    ], 2),
    (_ctx.url)
      ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          ref: "videoRef",
          poster: _ctx.poster,
          class: _normalizeClass(["w-full", {'bg-wild-sand': !_ctx.poster}]),
          role: "application",
          src: _ctx.url
        }, null, 10, _hoisted_14))
      : _createCommentVNode("", true)
  ], 32))
}